import React from "react";
import ToggleSwitch from "../../../shared/components/ToggleSwitch";
import { ArrowLeftOutlined } from "@ant-design/icons";
import CardMenu from "../../../shared/components/CourseComponents/CardMenu";
import "./instituteDetails.scss";
import { useHistory, useLocation } from "react-router-dom";
import faker from "faker";
import UserIcon from "../../../assets/icons/user-pink.svg";
import PhoneIcon from "../../../assets/icons/phone-blue.svg";
import MailIcon from "../../../assets/icons/mail-blue.svg";
import { InstituteBranch } from "./InstituteBranch";
import { InstituteSection } from "./InstituteSection";
import InstituteStudents from "./InstituteStudents";
import { Tabs } from "antd";
import { Institutes } from "../../../models/InstituteModel/institutes.model";
import InstituteTeachers from "./InstituteTeachers";
import InstituteLiveClass from "./InstituteLiveClass";
const { TabPane } = Tabs;
export const InstituteDetails = (props: any) => {
  const { user } = props;
  const { state }: { state: Institutes } = useLocation();
  const history = useHistory();
  return (
    <div className="page-view institute-details__container">
      <div className="institute-details__header">
        <div className="header-name__wrapper">
          <div className="header__left">
            {user?.roleName === 'admin' && <ArrowLeftOutlined onClick={() => history.goBack()} />}
            {state?.logoUrl && <img src={state?.logoUrl} />}

            <p>{state?.name}</p>
          </div>
          {/* <div className="header__right">
            <ToggleSwitch checked={true} handleChange={() => {}} />
            <CardMenu
              menuText="Institute"
              handleEdit={() => {}}
              handleDelete={() => {}}
            />
          </div> */}
        </div>
        <div className="institute-address__wrapper">
          <p>
            <span></span>
            {state?.registeredAddress}
          </p>
        </div>
        <div className="institute-contact__wrapper">
          <div className="contact__name">
            <span>
              <img src={UserIcon} />
            </span>
            {state?.contactPerson}
          </div>
          <div className="contact__phone">
            <span>
              <img src={PhoneIcon} />
            </span>
            {state?.phoneNumber}
          </div>
          <div className="contact__email">
            <span>
              <img src={MailIcon} />
            </span>
            {state?.email}
          </div>
        </div>
      </div>
      <Tabs defaultActiveKey="1">
        <TabPane tab="Branch" key="1">
          <InstituteBranch {...props}/>
        </TabPane>
        <TabPane tab="Sections" key="2">
          <InstituteSection {...props}/>
        </TabPane>
        <TabPane tab="Students" key="3">
          <InstituteStudents {...props}/>
        </TabPane>
        <TabPane tab="Teachers" key="4">
          <InstituteTeachers {...props}/>
        </TabPane>
        <TabPane tab="Live Class" key="5">
          <InstituteLiveClass {...props}/>
        </TabPane>
      </Tabs>
    </div>
  );
};
